import { FC, useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export interface PortalProps {
  selector: string;
}

export const Portal: FC<PortalProps> = ({ children, selector }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    ref.current = document.querySelector(selector);
    setMounted(true);
  }, [selector]);

  return mounted && ref.current ? createPortal(children, ref.current) : null;
};
export default Portal;
